import React from "react"
import "./consulting-content.scss"
import HeaderConsulting from "../../molecules/header-consulting/header-consulting"
import BodyConsulting from "../../molecules/body-consulting/body-consulting"
import FooterConsulting from "../../molecules/footer-consulting/footer-consulting"

const ConsultingContent = props => {
  const { mobile, params } = props

  return (
    <div className="f-consulting-content">
      <div className="f-consulting-content-wrapper">
        <HeaderConsulting mobile={mobile} banners={params.banners} />
        <BodyConsulting
          mobile={mobile}
          beneficios={params.beneficios}
          especialistas={params.especialistas}
        />
        <FooterConsulting
          mobile={mobile}
          params={params.muyImportante}
          image={params.imagenMuyImportante}
        />
      </div>
    </div>
  )
}

export default ConsultingContent
